import { connect } from 'react-redux';
import {ROUTES} from '../constants';
import HomePage from '../components/pages/HomePage';

const mapStateToProps = ({profileReducer},ownProps) => {
	return {
		...ownProps,
		profileReducer,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		onClickSearch : ()=>{
			dispatch({
				type: ROUTES.SEARCH_QUIZ_SELECTED
			});
		},
		onClickCreate : ()=>{
			dispatch({
				type: ROUTES.CREATE_QUIZ_SELECTED
			});
		}
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(HomePage);